module.exports = __webpack_public_path__ + "img/who.f6bc6fd3.svg";